import { useMemo } from "react";
import { getLabelsForAllQuestions } from "../model/GameStatsEvaluation";

export function VerticalDistributionComponent({ barColor="primary-light", labelColor="default-light", values, labels=getLabelsForAllQuestions(), unit="x" }) {
  const numValues = useMemo(() => labels.length, [labels]);
  const scaledValues = useMemo(() => scaleOnFullWidth(values, 1), [values]);

  return (<div className="vertical-container top-margin chart-container">
    {[...Array(numValues).keys()].map(i => 
      <div key={i} className="bar-container">
        <div className={`bar-label horizontal-container space-between ${labelColor}`}>
          <span>{labels[i]}-Frage</span>
          <span>{values[i] ?? 0} {unit}</span>
        </div>
        <div className={`bar ${barColor}`} style={{ width: `${scaledValues[i] * 100}%` }} />
      </div>
    )}
  </div>);
}


function scaleOnFullWidth(values, fullWidth) {
  const factor = fullWidth / Math.max(...values);
  return values.map(v => factor * v)
}